import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";

import {catchError, map, switchMap, tap} from "rxjs/operators";

import { Observable, throwError } from "rxjs";
import {select, Store} from '@ngrx/store';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

import { logout } from '../state/auth/auth.actions';
import {selectToken, selectAuthUser, selectIsLoggedIn, selectAuthState} from '../state/auth/auth.selectors';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private apiUrl = environment.api.url;
  private token$: Observable<string>;

  constructor (
    private http: HttpClient,
    private store: Store,

    private router: Router
  ) {
    this.token$ = this.token();
  }

  login(email: string, password: string): Observable<{token: string, user: any}> {
    const url = `${this.apiUrl}/login`;
    return this.http.post<any>(url, { email, password, device_name: 'desktop' }).pipe(
      map(response => {
        if (!response.token) {
          // If the token is not present in the response, throw an error
          throw new Error('Login failed: No token received');
        }
        // console.log('Login response:', response);
        return {
          token: response.token,
          user: response.user
        }
      }),
      catchError(error => {
        throw error;
      })
    );
  }

  logout(): Observable<{message: string}> {
    const url = `${this.apiUrl}/logout`;

    return this.token$.pipe(
      switchMap(token => {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          })
        };

        return this.http.post<any>(url, {}, httpOptions);
      }),
      map(response => {
        if (!response || !response.metadata.message) {
          // If the success field is false or not present, throw an error
          throw new Error('Logout failed: ' + (response ? response.message : 'No response'));
        }
        // console.log('Logout response:', response);
        return { message: response.metadata.message };
      }),
      catchError(error => {
        // Re-throw the error so it can be caught where the service is called
        return throwError(error);
      })
    );
  }

  /*
  // updateUser(user_id): Observable<{ user: any}> {
  //
  //
  //   // this.token().subscribe(token => {
  //   //   this.token = token;
  //   // });
  //   const url = `${this.apiUrl}/users/` + user_id;
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //       'Accept'  : 'application/json',
  //       'Accept-Language': 'en',
  //       'Authorization': `Bearer ${this.token}` // Use the token here
  //     })
  //   };
  //
  //   return this.http.get<any>(url,httpOptions ).pipe(
  //     map(response => {
  //       if (!response) {
  //         // If the token is not present in the response, throw an error
  //         throw new Error('Login failed: No token received');
  //       }
  //       console.log('Update User response:', response);
  //       return {
  //         user: response.user
  //       }
  //     }),
  //     catchError(error => {
  //       throw error;
  //     })
  //   );
  // }
  */

  token(): Observable<any | null> {
    return this.store.pipe(select(selectToken));
  }

  authUser(): Observable<any | null> {
    return this.store.pipe(select(selectAuthUser));
  }
  authState(): Observable<any | null> {
    return this.store.pipe(select(selectAuthState));
  }


  isLoggedIn(): Observable<any | null> {
    return this.store.pipe(select(selectIsLoggedIn));
  }

  register(name: string, email: string, linkedin_url: string, country_id: string, company_invoice: boolean = false, company_name: string = null, company_identifier: string = null, company_country_id: string = null, company_county: string = null, company_town: string = null, company_zip_code: string = null, company_address: string = null, is_tax_payer: boolean = false, password: string, password_confirmation: string,search_id:any, event: string = null): Observable<{ user: any }> {
    const url = `${this.apiUrl}/register`;
    return this.http.post<any>(url, { name, email, linkedin_url, country_id, company_invoice, company_name, company_identifier, company_country_id, company_county, company_town, company_zip_code, company_address, is_tax_payer, password, password_confirmation, search_id, event}).pipe(
      map(response => {
        if (!response.data.user) {
          throw new Error('Registration failed: No user received');
        }
        // console.log('Registration response:', response);
        return {
          user: response.data.user
        };
      }),
      catchError(error => {
        throw error;
      })
    );
  }

}
